import React, { Component } from "react";
import Select from 'react-select';
// Usar react-date-range (compatible con React 17)
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import 'moment/locale/es';
import '../styles/datepicker-override.css';
import '../styles/pagination-override.css';
import ReactPaginate from 'react-paginate';
import { LangContext } from "../LangContext.jsx";

moment.locale('es');
class ReportsDossierTemplates extends Component {

    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            dossierTemplates: [],
            currentPage: 0,
            itemsPerPage: 10,
            totalPages: 0,
            showFrom: 0,
            showTo: 0,
            totalDossierTemplates: 0,
            showExport: true,
            showRut: false,
            selectedId: null,
            selectedTitle: null,
            selectedRelation: null,
            selectedType: null,
            selectedUniqueDocsCount: null,
            selectedUniqueId: null,
            selectedRecurrentDocsCount: null,
            selectedRecurrentId: null,
            idOptions: [],
            titleOptions: [],
            uniqueDocsOptions: [],
            recurrentDocsOptions: [],
            uniqueDocsCountOptions: [],
            recurrentDocsCountOptions: [],
            relationOptions: [
                {value: "Proveedor", label: "Proveedor"},
                {value: "Empleado", label: "Empleado"},
                {value: "Cliente", label: "Cliente"},
            ],
            typeOptions: [
                {value: "Especiales", label: "Especiales"},
                {value: "Internacional", label: "Internacional"},
                {value: "Nacional", label: "Nacional"},
            ],
            showAdvancedFilters: false,
            focusedInput: null,
            startDate: null,
            endDate: null,
            showCreatedPicker: false,
            params : {
                dossierTemplate:{
                    id: null,
                    created_at: null,
                    title: null,
                    dossier_target_name: null,
                    dossier_type_title: null,
                    unique_docs: null,
                    recurrent_docs: null,
                    unique_docs_count: null,
                    recurrent_docs_count: null
                },
                sort:{
                    order: null,
                    column: null
                },
                page: 0,
                limit:  10,
            },
        };
        this.createdPickerRef = React.createRef();
    }

    getDossierTemplates(){
        const { currentPage, itemsPerPage } = this.state;
        axios.get('/api/reports/dossiers_template', {
                params: {
                    ...this.state.params,
                    page: currentPage +1,
                    limit: itemsPerPage
                }
            }).then(res=>{
                let dossierTemplates = res.data.data;

                dossierTemplates = dossierTemplates.map(template => {
                    if (template.unique_docs) {
                        template.unique_docs = template.unique_docs.split(',').map(id => 'U' + id).join(', ');
                    }
                    if (template.recurrent_docs) {
                        template.recurrent_docs = template.recurrent_docs.split(',').map(id => 'U' + id).join(', ');
                    }
                    return template;
                });

                this.setState({
                    dossierTemplates,
                    showFrom: res.data.from,
                    showTo: res.data.to,
                    totalDossierTemplates: res.data.total,
                    totalPages: Math.ceil(res.data.total / itemsPerPage)
                });
        })
        this.getFilters();
    }

    getFilters() {
        axios.get('/api/filters/dossiers_template', {
            params: {
                ...this.state.params,
            }
        }).then((res) => {
            const dossierTemplateFilters = res.data;
            this.setState({
                idOptions: dossierTemplateFilters.idOptions,
                titleOptions: dossierTemplateFilters.titleOptions,
                uniqueDocsOptions: dossierTemplateFilters.uniqueDocsOptions,
                uniqueDocsCountOptions: dossierTemplateFilters.uniqueDocsCountOptions,
                recurrentDocsOptions: dossierTemplateFilters.recurrentDocsOptions,
                recurrentDocsCountOptions: dossierTemplateFilters.recurrentDocsCountOptions
            });
        });
    }

    exportReports() {
        const ids = this.state.idOptions.map(item => {
            const id = item.value.split('-')[1];
            return id;
        });
        const dataJSON = JSON.stringify(ids);

        axios.post('/api/export/dossiers_template', {
            data: dataJSON,
        }, {
            responseType: 'blob',
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');

            const fileName = 'ReportePlantillaExpedientes.xls';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }

    componentDidMount() {
        this.getDossierTemplates();
        document.addEventListener('mousedown', this.handleClickOutside);
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleIdChange = (event) => {
        let value = (event) ? event.value.split('E-')[1] : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                id: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedId: event,
        }, this.getDossierTemplates);
    }

    handleTitleChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                title: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedTitle: event,
        }, this.getDossierTemplates);
    }

    handleRelationChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                dossier_target_name: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRelation: event,
        }, this.getDossierTemplates);
    }

    handleTypeChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                dossier_type_title: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedType: event,
        }, this.getDossierTemplates);
    }

    handleUniqueDocCountChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                unique_docs_count: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedUniqueDocsCount: event,
        }, this.getDossierTemplates);
    }

    handleUniqueIdChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                unique_docs: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedUniqueId: event,
        }, this.getDossierTemplates);
    }

    handleRecurrentDocCountChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                recurrent_docs_count: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRecurrentDocsCount: event,
        }, this.getDossierTemplates);
    }

    handleRecurrentIdChange = (event) => {
        let value = (event) ? event.value : null;

        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                recurrent_docs: value
            }
        };

        this.resetCurrentPage();
        this.setState({
            params: updatedParams,
            selectedRecurrentId: event,
        }, this.getDossierTemplates);
    }

    handleDateChange = (ranges) => {
        const sel = ranges.selection || {};
        const startDate = sel.startDate || null;
        const endDate = sel.endDate || null;
        const startStr = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endStr = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                created_at: { startDate: startStr, endDate: endStr }
            }
        };

        this.resetCurrentPage();
        this.setState({
            startDate: startStr,
            endDate: endStr,
            params: updatedParams
        }, this.getDossierTemplates);
    }

    toggleCreatedPicker = () => this.setState(prev => ({ showCreatedPicker: !prev.showCreatedPicker }));
    handleClickOutside = (e) => {
        if (this.state.showCreatedPicker && this.createdPickerRef.current && !this.createdPickerRef.current.contains(e.target)) {
            this.setState({ showCreatedPicker: false });
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        this.setState({ currentPage: selected }, this.getDossierTemplates);
    }

    handleItemsPerPageChange = (event) => {
        const newItemsPerPage = parseInt(event.target.value, 10);
        this.setState({
            itemsPerPage: newItemsPerPage,
            currentPage: 0
        }, this.getDossierTemplates);
    };

    resetCurrentPage = () => {
        this.setState({
            currentPage: 0,
        });
    }

    clearDates = () => {
        const updatedParams = {
            ...this.state.params,
            dossierTemplate: {
                ...this.state.params.dossierTemplate,
                created_at: {startDate: null, endDate: null}
            }
        };

        this.setState({
            params: updatedParams,
            startDate: null,
            endDate: null
        }, this.getDossierTemplates);
    }

    clearFilters = () => {
        this.setState({
            selectedId: null,
            selectedTitle: null,
            selectedRelation: null,
            selectedType: null,
            selectedUniqueDocsCount: null,
            selectedUniqueId: null,
            selectedRecurrentDocsCount: null,
            selectedRecurrentId: null,
            startDate: null,
            endDate: null,
            params : {
                dossierTemplate:{
                    id: null,
                    created_at: null,
                    title: null,
                    dossier_target_name: null,
                    dossier_type_title: null,
                    unique_docs: null,
                    recurrent_docs: null,
                    unique_docs_count: null,
                    recurrent_docs_count: null
                },
                sort:{
                    order: null,
                    column: null
                },
            },
        }, this.getDossierTemplates);
    };

    handleSort = (column) => {
        this.setState(prevState => {
            if (column === prevState.params.sort.column) {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: prevState.params.sort.order === 'asc' ? 'desc' : 'asc'
                        }
                    }
                };
            } else {
                return {
                    params: {
                        ...prevState.params,
                        sort: {
                            ...prevState.params.sort,
                            column: column,
                            order: 'asc'
                        }
                    }
                };
            }
        }, this.getDossierTemplates);
    };

    toggleAdvancedFilters = () => {
        this.setState(prevState => ({
            showAdvancedFilters: !prevState.showAdvancedFilters
        }));
    };

    render() {
        const { lang } = this.context; 
    return (
        <>
            <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                    <div>
                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                            {lang.get('messages.reporte_de_plantilla_de_expedientes')}
                        </h5>
                        <p className="text-dark-50 font-weight-bold my-1 mr-5">
                            <span className="text-primary datatable-count">{this.state.totalDossierTemplates}</span> Plantillas Generadas.
                        </p>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                        {this.state.showExport &&
                            <a
                                id="export"
                                className="btn btn-primary px-10 font-weight-bolder"
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.exportReports();
                                }}
                                >{lang.get('messages.exportar')}</a>
                        }
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="datatable-filters">
                    <div className="d-flex justify-content-between mb-4">
                        <div className="font-weight-bolder">{lang.get('messages.filtrar_por')}:</div>
                        <a
                            className="datatable-clear-filters float-right text-primary"
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                this.clearFilters();
                            }}
                        ><strong>{lang.get('messages.limpiar_todos_los_filtros')}</strong></a>
                    </div>

                    <div className="d-flex justify-content-between mb-4 default">
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Id</label>
                            <Select
                                value={this.state.selectedId}
                                onChange={this.handleIdChange}
                                options={this.state.idOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_id')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.nombre_de_plantilla')}</label>
                            <Select
                                value={this.state.selectedTitle}
                                onChange={this.handleTitleChange}
                                options={this.state.titleOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_nombre_de_plantilla')}</div>}
                                isClearable={true}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="mb-0 text-dark-50 font-weight-bold">Relación</label>
                            <Select
                                value={this.state.selectedRelation}
                                onChange={this.handleRelationChange}
                                options={this.state.relationOptions}
                                placeholder={<div>{lang.get('messages.buscar_por_relacion')}</div>}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    {this.state.showAdvancedFilters && (
                        <div className="advanced-filters">
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">Tipo</label>
                                    <Select
                                        value={this.state.selectedType}
                                        onChange={this.handleTypeChange}
                                        options={this.state.typeOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por_tipo')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">No. Docs {lang.get('messages.unicos')}</label>
                                    <Select
                                        value={this.state.selectedUniqueDocsCount}
                                        onChange={this.handleUniqueDocCountChange}
                                        options={this.state.uniqueDocsCountOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por')} No. Docs {lang.get('messages.unicos')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">ID's Docs {lang.get('messages.unicos')}</label>
                                    <Select
                                        value={this.state.selectedUniqueId}
                                        onChange={this.handleUniqueIdChange}
                                        options={this.state.uniqueDocsOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por')} ID's Docs {lang.get('messages.unicos')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-between mb-4 default">
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">No. Docs {lang.get('messages.recurrentes')}</label>
                                    <Select
                                        value={this.state.selectedRecurrentDocsCount}
                                        onChange={this.handleRecurrentDocCountChange}
                                        options={this.state.recurrentDocsCountOptions}
                                        placeholder={<div>{lang.get('messages.buscar_por')} No. Docs {lang.get('messages.recurrentes')}</div>}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label className="mb-0 text-dark-50 font-weight-bold">ID's Docs {lang.get('messages.recurrentes')}</label>
                                    <Select
                                        value={this.state.selectedRecurrentId}
                                        placeholder={<div>{lang.get('messages.buscar_por')} ID's Docs {lang.get('messages.recurrentes')}</div>}
                                        onChange={this.handleRecurrentIdChange}
                                        options={this.state.recurrentDocsOptions}
                                        isClearable={true}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <div className="datepicker-container">
                                        <label className="mb-0 text-dark-50 font-weight-bold">{lang.get('messages.fecha_de_creacion')}</label><br></br>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                className="form-control d-flex align-items-center justify-content-between"
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.toggleCreatedPicker}
                                            >
                                                <span>{this.state.startDate ? moment(this.state.startDate).format('ll') : lang.get('messages.fecha_inicio')}</span>
                                                <span className="mx-2">–</span>
                                                <span>{this.state.endDate ? moment(this.state.endDate).format('ll') : lang.get('messages.fecha_fin')}</span>
                                                {(this.state.startDate || this.state.endDate) && (
                                                    <span onClick={(e) => { e.stopPropagation(); this.clearDates(); }} style={{ marginLeft: 'auto' }}>
                                                        <i className="flaticon2-delete text-muted"></i>
                                                    </span>
                                                )}
                                            </div>

                                            {this.state.showCreatedPicker && (
                                                <div ref={this.createdPickerRef} className="date-range-popover">
                                                    <DateRange
                                                        ranges={[{
                                                            startDate: this.state.startDate ? new Date(this.state.startDate) : new Date(),
                                                            endDate: this.state.endDate ? new Date(this.state.endDate) : new Date(),
                                                            key: 'selection'
                                                        }]}
                                                        onChange={this.handleDateChange}
                                                        editableDateInputs={true}
                                                        moveRangeOnFirstSelection={false}
                                                        months={1}
                                                        direction="horizontal"
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {this.state.showAdvancedFilters == false &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-down mr-2"></span> {lang.get('messages.mostrar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                    {this.state.showAdvancedFilters == true &&
                        <div className="my-4">
                            <a href="#"
                            className="text-primary font-weight-bold"
                            onClick={(e) => {
                                e.preventDefault();
                                this.toggleAdvancedFilters();
                            }}>
                                <span className="flaticon2-up mr-2"></span> {lang.get('messages.ocultar_filtros_avanzados')}
                            </a>
                        </div>
                    }
                </div>
                <div className="table-responsive">
                    <table className="table table-report w-100" id="datatable">
                        <thead>
                            <tr>
                                <th style={{ width: '80px' }} onClick={() => this.handleSort('id')}>
                                    Id
                                    {this.state.params.sort.column === 'id' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '350px' }} onClick={() => this.handleSort('title')}>
                                    {lang.get('messages.nombre_de_plantilla')}
                                    {this.state.params.sort.column === 'title' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('dossier_target_name')}>
                                    {lang.get('messages.relacion')}
                                    {this.state.params.sort.column === 'dossier_target_name' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('dossier_type_title')}>
                                    {lang.get('messages.tipo')}
                                    {this.state.params.sort.column === 'dossier_type_title' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('unique_docs_count')}>
                                    No. Docs {lang.get('messages.unicos')}
                                    {this.state.params.sort.column === 'unique_docs_count' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('unique_docs')}>
                                    ID's Docs {lang.get('messages.unicos')}
                                    {this.state.params.sort.column === 'unique_docs' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('recurrent_docs_count')}>
                                    No. Docs {lang.get('messages.recurrentes')}
                                    {this.state.params.sort.column === 'recurrent_docs_count' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{ width: '150px' }} onClick={() => this.handleSort('recurrent_docs')}>
                                    ID's Docs {lang.get('messages.recurrentes')}
                                    {this.state.params.sort.column === 'recurrent_docs' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                                <th style={{width: '200px'}} onClick={() => this.handleSort('created_at')}>
                                    {lang.get('messages.fecha_de_creacion')}
                                    {this.state.params.sort.column === 'created_at' &&
                                        (this.state.params.sort.order === 'asc' ?
                                            <span className="flaticon2-up mx-2" style={{ color: '#844AFF' }}></span> :
                                            <span className="flaticon2-down mx-2" style={{ color: '#844AFF' }}></span>)
                                    }
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.dossierTemplates.map((dossier_template) => (
                                <tr key={dossier_template.id} id={dossier_template.id}>
                                    <td className="text-dark-75 font-weight-bolder">{`E-${dossier_template.id}`}</td>
                                    <td className="text-dark-50 font-weight-bold">{dossier_template.title +" "+dossier_template.id}</td>
                                    <td className="text-dark-75 font-weight-bolder">{lang.get('messages.'+dossier_template.dossier_target_name.toLowerCase())}</td>
                                    <td className="text-dark-50 font-weight-bold">
                                    {lang.get('messages.'+dossier_template.dossier_type_title.toLowerCase())}
                                        </td>
                                    <td className="text-dark-75 font-weight-bolder text-center">
                                        {dossier_template.unique_docs_count}
                                    </td>
                                    <td className="text-dark-50 font-weight-bold text-center">
                                        {dossier_template.unique_docs}
                                    </td>
                                    <td className="text-dark-75 font-weight-bolder text-center">
                                        {dossier_template.recurrent_docs_count}
                                    </td>
                                    <td className="text-dark-50 font-weight-bold text-center">
                                        {dossier_template.recurrent_docs}
                                    </td>
                                    <td className="text-dark-75 font-weight-bolder"
                                        data-sort={dossier_template.created_at === '' ? '' : new Date(dossier_template.created_at).toISOString().slice(0,10)}>
                                        {dossier_template.created_at === '' ? '' : new Date(dossier_template.created_at).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between">
                        <div className="col mt-2 px-0">
                            {lang.get('messages.mostrando_del')} {this.state.showFrom} {lang.get('messages.al')} {this.state.showTo} {lang.get('messages.de')} {this.state.totalDossierTemplates} {lang.get('messages.registros')}.
                        </div>
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <p className="mr-2 mt-2">
                                    {lang.get('messages.mostrar')}:
                                </p>
                                <select
                                    value={this.state.itemsPerPage}
                                    onChange={this.handleItemsPerPageChange}
                                    aria-controls="datatable"
                                    className="custom-select custom-select-sm form-control form-control-sm"
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </div>
                            <ReactPaginate
                                previousLabel={'< ' + lang.get('messages.anterior')}  
                                nextLabel={ lang.get('messages.siguiente') + ' >'} 
                                breakLabel={'...'}
                                breakClassName={'break-me'}
                                pageCount={this.state.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={'pagination'}
                                activeClassName={'active'}
                                previousClassName={'previous'}
                                nextClassName={'next'}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
      );
    }
}

export default ReportsDossierTemplates;
